import React from 'react';
import MarketCard from './MarketCard';
import { credits } from './nxlUtils';

function HotMarkets(props) {
  const safeHotMarkets = Array.isArray(props?.hotMarkets)
    ? props.hotMarkets
    : [];

  const selectedMarket = props?.selectedMarket || null;
  const setSelectedMarket =
    typeof props?.setSelectedMarket === 'function'
      ? props.setSelectedMarket
      : () => {};

  return (
    <section className="nxl-panel">
      <div className="nxl-section-heading">
        <div>
          <p className="nxl-kicker">HOT MARKETS</p>
          <h2>Most active pools</h2>
          <p className="nxl-muted">
            Ranked by credits wagered, then ticket count.
          </p>
        </div>
      </div>

      <div className="nxl-hot-list">
        {safeHotMarkets.map((item, index) => {
          const market = item?.market || item;
          const pool = item?.pool || {};

          if (!market?._id) return null;

          return (
            <div className="nxl-hot-item" key={market._id}>
              <div className="nxl-hot-rank">#{index + 1}</div>

              <div className="nxl-hot-market">
                <MarketCard
                  market={market}
                  selected={selectedMarket?._id === market._id}
                  onSelect={setSelectedMarket}
                />

                <div className="nxl-hot-stats">
                  <span>{credits(pool?.credits_wagered || 0)} credits</span>
                  <span>{pool?.positions || 0} tickets</span>
                </div>
              </div>
            </div>
          );
        })}

        {!safeHotMarkets.length && (
          <p className="nxl-muted">
            Hot markets will appear after pool activity begins.
          </p>
        )}
      </div>
    </section>
  );
}

export default HotMarkets;